import React from 'react';
import { observer } from 'mobx-react';
import { computed, observable } from 'mobx';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import LanguageButton from 'components/button/language_button';
import styled from '@emotion/styled';
import { Constants, Theme } from '@seedlang/constants';
import SpecialCharacterButtons from 'components/special_character_buttons';
import { AppUI, ExerciseUI } from '@seedlang/state';
import { underlineWronglyPositionedCharacters } from '@seedlang/utils';

const Wrapper = styled.div`
  margin: ${props => props.margin};
`;

const Source = styled.div`

`;

const InputWrapper = styled.div`
  input {
    background: ${props => props.background};
    color: ${props => props.background ? '#FFF' : '#000'};
    font-size: 16px;
    padding: 10px;
  }
`;

const RevealedText = styled.div`
    background: ${props => props.background};
    color: ${props => props.background ? '#FFF' : '#000'};
    font-size: 16px;
    padding: 10px;
    border: 1px solid #bcbcbc;
    line-height: 20px;
    max-width: 100%;
    width: 100%;
    border-radius: 4px;
`;

@observer
class ExerciseSentenceEnterInput extends React.Component {
  @observable showSource = false;

  @computed get languageId() {
    const sentence = this.props.exerciseEntry.sentence;
    return this.showSource ? sentence.sourceTextForUserLanguageId(AppUI.user) : sentence.languageId;
  }

  @computed get background() {
    if (this.props.exerciseEntry.state.revealed && this.props.exerciseEntry.state.correct) {
      return Theme.green;
    } else if (this.props.exerciseEntry.state.revealed && !this.props.exerciseEntry.state.correct) {
      return Theme.red;
    } else return '';
  }
  insertText = (text) => {
    const el = document.getElementById(this.props.exerciseEntry.id);

    if (!el) return;

    const caretPosition = el.selectionStart;
    el.focus();
    const newValue = [this.props.exerciseEntry.state.submittedValue?.slice(0, caretPosition), text, this.props.exerciseEntry.state.submittedValue?.slice(caretPosition)].join('');
    this.props.exerciseEntry.state.set('submittedValue', newValue);
    setTimeout(() => {
      el.setSelectionRange(caretPosition + 1, caretPosition + 1);
    }, 0);
  }

  @computed get _revealedText() {
    if (
      this.props.exerciseEntry.state.correct
      && this.props.exerciseEntry.sentence.targetText.trim().length === this.props.exerciseEntry.state.submittedValue?.trim().length
      && (this.props.exerciseEntry.state.incorrectCasing || this.props.exerciseEntry.state.incorrectSpecialCharacters || this.props.exerciseEntry.state.incorrectPunctuation)
    ) {
      return underlineWronglyPositionedCharacters(
        this.props.exerciseEntry.sentence.targetText,
        this.props.exerciseEntry.state.submittedValue,
      );
    }

    if (this.props.exerciseEntry.state.correct) {
      return this.props.exerciseEntry.sentence.targetText;
    }

    return this.props.exerciseEntry.state.submittedValue;
  }

  render() {
    return (
      <Wrapper
        margin={this.props.margin}
      >
        {
          this.props.exerciseEntry.sentence.sourceTextForUser(AppUI.user) &&
            <LanguageButton
              languageId={this.languageId}
              onClick={() => this.showSource = !this.showSource}
            />
        }
        {
          !this.showSource &&
            <InputWrapper
              background={this.background}
            >
              {
                !this.props.exerciseEntry.state.revealed &&
                  <input
                    type='text'
                    autoComplete='off'
                    id={this.props.exerciseEntry.id}
                    value={this.props.exerciseEntry.state.submittedValue || ''}
                    onChange={e => this.props.exerciseEntry.state.set('submittedValue', e.currentTarget.value)}
                    onFocus={this.props.onFocus}
                    onKeyUp={e => e.keyCode === 13 && this.props.revealOnEnter ? ExerciseUI.revealExerciseEntryAnswer(this.props.exerciseEntry, {}, this.props.afterReveal) : null}
                  />
              }
              {
                this.props.exerciseEntry.state.revealed &&
                  <RevealedText
                    background={this.background}
                    dangerouslySetInnerHTML={{ __html: this._revealedText }}
                  />
              }
            </InputWrapper>
        }
        {
          this.showSource &&
            <Source>
              {this.props.exerciseEntry.sentence.sourceTextForUser(AppUI.user)}
            </Source>
        }
        {
          this.props.isFocused &&
            <SpecialCharacterButtons
              margin='10px 0 0 0'
              showCloseButton
              languageId={ExerciseUI.groupId === Constants.EASY_GERMAN_GROUP_ID ? 'DE' : null}
              onClick={this.insertText}
            />
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(ExerciseSentenceEnterInput);
